import JSON5 from 'json5';
export const prettyFormatJsonString = payload => {
    try {
        let value;
        if(!payload) {
            value = {};
        }
        else if (typeof payload === 'object') {
            value = payload
        } else {
            const parsed = JSON5.parse(payload)
            if (parsed["archived_file_url"])
                parsed["archived_file_url"] = parsed["archived_file_url"].split(',');
            value = parsed
        }

        return JSON.stringify(value, null, 2);
    } catch {
        return payload
    }
};
